module.exports = __webpack_public_path__ + "static/img/duiduoduo_wxPub.4551a754.png";